import { render, staticRenderFns } from "./DashboardCro.vue?vue&type=template&id=605e5316&"
import script from "./DashboardCro.vue?vue&type=script&lang=js&"
export * from "./DashboardCro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports